<template>
  <div class="ma-4">
    <v-snackbar v-model="msg" top> {{ text }}
      <v-btn color="pink" text @click="msg = false"> Close</v-btn>
    </v-snackbar>
    <v-card>
      <v-layout row wrap class="pa-2 ma-2 hideOnPrint">
        <v-flex xs12>
          <v-btn fab x-small @click="$router.go(-1)">
            <v-icon>navigate_before</v-icon>

          </v-btn>
        </v-flex>

        <v-flex xs12 md1 class="mb-2">
          <v-btn
            fab
            small
            @click="printTable()"
            class="ml-8 white--text"
            color="#2b6993"
            elevation="4"
            right
            absolute
          >
            <v-icon>print</v-icon>
          </v-btn>
        </v-flex>

        <v-flex xs12>
          <h3 class="text-center mb-5">Incident Reports</h3>
          <v-divider class="ml-4 mr-4 mb-3"></v-divider>
        </v-flex>

        <v-flex xs12>
          <v-card
            class="ma-3 pa-3"
            elevation="0"
          >
            <v-layout row wrap>
              <v-flex xs12 md2 class="pa-1">
                <DatePicker
                  v-model="filters.startDate"
                  label="Start Date"
                  :defaultDate="filters.startDate"
                  :rules='requiredField'
                />
              </v-flex>

              <v-flex xs12 md2 class="pa-1">
                <v-menu
                  ref="calendarMenu2"
                  v-model="calendarMenu2"
                  :close-on-content-click="false"
                  :return-value.sync="date"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="filters.endDate"
                      label="End Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :rules='requiredField'

                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="filters.endDate"
                    no-title
                    scrollable
                    :rules='requiredField'

                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="calendarMenu2 = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.calendarMenu2.save(date)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex xs12 md2 class="pa-1 mb-2">
                <v-select
                  label="Select a Program"
                  :items="programs"
                  item-text="Name"
                  item-value="Name"
                  v-model="filters.program"
                  clearable
                  @change="incidentQuery"
                ></v-select>
              </v-flex>

              <v-flex xs12 md2 class="pa-1 mb-2">
                <v-select
                  label="Client Status"
                  :items="clientStatuses"
                  v-model="clientStatus"
                  clearable
                  @change="incidentQuery"
                ></v-select>
              </v-flex>

              <v-flex xs12 md2 class="pa-1 mb-2">
                <v-select
                  label="Select a Client"
                  :items="filteredClients"
                  item-text="Name"
                  item-value="_id"
                  v-model="filters.ClientID"
                  clearable
                  @change="incidentQuery"
                ></v-select>
              </v-flex>

              <!-- <v-flex xs12 md2 class="pa-1 mb-2"> -->
              <!--                  <v-select-->
              <!--                    :items="states"-->
              <!--                    v-model="state"-->
              <!--                    label="State"-->
              <!--                    clearable-->
              <!--                    @change="incidentQuery"-->
              <!--                  ></v-select>-->
              <!-- <v-switch
                  v-show="userRole === 'Administration'"
                  v-model="isUtahIncidentReports"
                  inset
                  :label="(isUtahIncidentReports ? 'Utah' : 'Nevada') + ' Incident Reports'"
                  @change="incidentQuery"
              ></v-switch> -->
              <!-- </v-flex> -->


              <v-flex xs12 md2 class="mt-5 mb-5 pl-5">
                <v-btn small @click="incidentQuery()">Search</v-btn>
              </v-flex>

            </v-layout>
          </v-card>
        </v-flex>

        <v-flex xs12 class="pa-2">
          <v-data-table
            :page="page"
            :pageCount="pageCount"
            :server-items-length="itemCount"
            :options.sync="options"
            :headers="headers"
            :items="incidents"
            sort-by="Name"
            sort-asc
            class="elevation-1"
            :loading="isLoading"
            loading-text="Loading Incident Reports"
          >
            <template v-slot:item.select="{ item }">
              <v-btn
                x-small
                class="white--text"
                color="#2b3990"
                @click="viewIncidentReport(item)"
              >
                View
              </v-btn>
              <v-btn
                x-small
                class="white--text ml-2"
                color="#2b3990"
                @click="downloadIncidentReport(item)"
              >
                Download
              </v-btn>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-card>

    <div id="print">
      <report-header>
        <h2>Incident Reports</h2>
      </report-header>
      <v-row>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="incidents"
            class="elevation-1"
            :loading="isLoading"
            loading-text="Loading Incident Reports"
            :page="page"
            :pageCount="pageCount"
            :server-items-length="itemCount"
            :options.sync="options"
          >
          </v-data-table>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
// import Foot from '../components/Footer'
import Swal from 'sweetalert2';
import DateTimeUtil from "../../../utils/date-time.util";
import {STATUS_ARRAY} from '../../enums/UserStatusEnum';
import ReportHeader from '@/components/Report/ReportHeader.vue';
import {DateTime} from 'luxon';
import DatePicker from "@/components/DateTimePickers/DatePicker.vue";

const url = require("../../client_config/config").url;
const IncidentService = require('../../service/incident.service');

export default {
  components: {
    DatePicker,
    ReportHeader
  },
  data: () => ({
    headers: [
      {
        text: 'Incident Date',
        align: 'start',
        sortable: true,
        value: 'IncidentDateTime',
      },
      {text: "Client", value: "ClientInfo.Name", sortable: true},
      {text: "Incident Type", value: "Type", sortable: true},
      {text: "Signatories", value: "Signatories", sortable: true},
      {text: "Program", value: "Program", sortable: true},
      {text: "DSPD/OL Notification Submitted", value: "ReportSubmitted", width: "10%"},
      {text: "", value: "select"},

      // { text: "Actions", value: "actions", sortable: false },
    ],
    printHeaders: [
      {
        text: 'Date',
        align: 'start',
        sortable: true,
        value: 'IncidentDateTime',
      },
      {text: "Client", value: "ClientID.Name"},
      {text: "Type", value: "Type"},
      {text: "Discovery Date", value: "IncidentDiscovered"},
      {text: "Date of the Report", value: "ReportReceived"},


      {text: "Program", value: "Program"},
      {text: "DSPD/OL Notification Submitted", value: "ReportSubmitted", width: "10%"},
      {text: "Duration (Incident Date & Discovery date)", value: "incidentToDiscoveryDateDuration"},
      {text: "Duration (Discover Date & DSPD date)", value: "discoveryToDSPDDateDuration"},

      // { text: "Actions", value: "actions", sortable: false },
    ],
    state: '',
    calendarMenu: false,
    calendarMenu1: false,
    calendarMenu2: false,
    calendarMenu3: false,
    report: '',
    clientName: '',
    isLoading: false,
    msg: false,
    text: '',
    date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    search: "",
    pageName: 'Incidents',
    clients: [],
    incidents: [],
    programs: [],
    units: [],
    users: [],
    staff: localStorage.getItem('Name'),
    codes: [],
    tempData: "",
    userID: localStorage.getItem("userID"),
    unitID: localStorage.getItem('unitID'),
    userState: localStorage.getItem('userState'),
    userRole: localStorage.getItem('userRole'),
    pageCount: 1,
    itemCount: 0,
    page: 1,
    options: {},
    clientStatus: "",
    clientStatuses: STATUS_ARRAY,
    filteredClients: [],
    requiredField: [v => !!v || 'Field is required'],
    filters: {
      startDate: '',
      endDate: '',
      program: '',
      clientStatus: '',
      ClientID: '',
      page: 1,
      itemsPerPage: 10
    }
  }),

  computed: {},

  watch: {
    clientStatus: function (val) {
      if (val === '' || val == null) this.filteredClients = this.clients;
      else this.filteredClients = this.clients.filter((client) => client.Status === val);

      this.filters.clientStatus = val;
    },
    options: {
      handler() {
        this.incidentQuery();
      },
      deep: true
    },
    filters: {
      handler() {
        this.setFilters();
      },
      deep: true
    }
  },

  created() {
    this.getClients();
    this.getPrograms();
    // this.incidentQuery();
    this.getStaffs();
    this.getFilters();
  },

  methods: {
    initialize() {
      this.clients = [];
    },

    async getClients() {
      let params = {};
      let endpoint = `${url}/clients`;

      const companyIds = localStorage.getItem('userCompanies');

      params['Company:in'] = JSON.parse(companyIds);
      params['State'] = this.userState;

      await axios.get(endpoint, {params})
        .then((res) => {
          this.clients = res.data.clients;
          this.filteredClients = this.clients;
        });
    },

    async getPrograms() {
      await axios.get(`${url}/units/state/${this.userState}`)
        .then((res) => {
          this.programs = res.data.units;
        });
    },

    getRights(id) {
      axios.get(`${url}/rights/${id}`).then(res => {
        this.rights = res.data.rights;
      })
    },

    getStaffs() {
      this.staffs = [];

      axios.get(`${url}/employees`).then(async res => {

        res.data.employees.forEach(employee => {
          this.staffs.push(employee.Name);
        });
      });

      this.isLoading = false;
    },

    incidentQuery() {
      this.incidents = [];
      this.isLoading = true;
      let startDate;
      let endDate;
      let today = DateTime.now();
      let lastMonth = DateTime.now().minus({months: 1});
      let defaultEndDate = today.toFormat('yyyy-MM-dd');
      let defaultStartDate = lastMonth.toFormat('yyyy-MM-dd');
      let {page, itemsPerPage, sortBy, sortDesc} = this.options;
      page = page || 1;
      itemsPerPage = itemsPerPage || 10;
      let sortField = '';

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0];
      }

      let sortDirection = '';

      if (sortDesc && sortDesc.length > 0) {
        sortDirection = sortDesc[0] ? 'desc' : 'asc';
      }

      this.program = this.filters.program || '';
      this.ClientID = this.filters.ClientID || '';

      if (this.filters.startDate) {
        startDate = new Date(this.filters.startDate);
        startDate.setHours(0, 0, 0);
        startDate.toISOString()
      } else {
        startDate = new Date(defaultStartDate);
        startDate.setHours(0, 0, 0);
        startDate.toISOString()
      }

      if (this.filters.endDate) {
        endDate = new Date(this.filters.endDate);
        endDate.setHours(23, 59, 59);
        endDate.toISOString()
      } else {
        endDate = new Date(defaultEndDate);
        endDate.setHours(0, 0, 0);
        endDate.toISOString()
      }

      const params = {
        program: this.filters.program,
        startDate: startDate,
        endDate: endDate,
        clientID: this.filters.ClientID,
        clientStatus: this.filters.clientStatus,
        state: this.userState,
        page: page,
        limit: itemsPerPage,
        sortField,
        sortDirection
      };

      IncidentService.getReport(params)
        .then(response => {
          const {docs, totalPages, totalDocs} = response.data;

          let filteredIncidents = docs.map(incident => ({
            ...incident,
            IncidentDateTime: DateTimeUtil.toLocalDateTime(incident.IncidentDateTime)
          }));

          if (this.filters.startDate && this.filters.endDate) {
            filteredIncidents = filteredIncidents.filter(incident => {
              const localDateTime = DateTime.fromFormat(incident.IncidentDateTime, 'yyyy-LL-dd, hh:mm:ss a');
              const localDateOnly = localDateTime.toFormat('yyyy-MM-dd');
              
              return localDateOnly >= this.filters.startDate && 
                     localDateOnly <= this.filters.endDate;
            });
          }

          this.incidents = filteredIncidents.sort((a, b) => {
            return new Date(b.IncidentDateTime) - new Date(a.IncidentDateTime);
          });

          this.pageCount = totalPages;
          this.itemCount = totalDocs;

        }).finally(() => {
        this.isLoading = false;
        this.formatSignatories();
      })
    },

    downloadIncidentReport(item) {

      let id = item._id;
      const downloadUrl = `${url}/incidents/print?id=${id}`;

      // Show the "Downloading" modal
      Swal.fire({
        title: 'Downloading',
        text: 'Please wait while the PDF is being generated and downloaded...',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      // Make a request to the backend API to generate the PDF
      fetch(downloadUrl)
        .then((response) => response.blob())
        .then((blob) => {
          // Create a temporary anchor tag
          const anchor = document.createElement('a');
          anchor.href = URL.createObjectURL(blob);
          anchor.download = `IncidentReport-${item._id}.pdf`;

          // Trigger the download
          document.body.appendChild(anchor);
          anchor.click();
          document.body.removeChild(anchor);

          // Close the modal when the download is complete
          Swal.close();
        })
        .catch((error) => {
          console.error('Error generating or downloading the PDF:', error);
          Swal.fire('Error', 'Failed to generate or download the PDF', 'error');
        });
    },

    viewIncidentReport(item) {
      this.$router.push({
        path: `/incidents/view-incident/${item._id}`,
        query: {clientNav: 'false', 'newIncident': 'false'}
      });
    },

    formatSignatories() {
      this.incidents.forEach(incident => {
        if (incident.SubmittedDSPDSignature) {
          let parts = incident.SubmittedDSPDSignature.split(' - ');
          let formattedSignatory = parts.slice(0, 2).join(', ');
          incident.Signatories = formattedSignatory;
        } else {
          incident.Signatories = 'No signatory data';
        }
      });
    },

    printTable() {
      this.incidentQuery();
      window.print()
    },

    getFilters() {
      let filters = localStorage.getItem('incidentReportFilters');
      if (filters) {
        this.filters = JSON.parse(filters);
        this.clientStatus = this.filters.clientStatus;
      }
    },

    setFilters() {
      localStorage.setItem('incidentReportFilters', JSON.stringify(this.filters));
    },
  }
}
</script>
<style>
#print {
  display: none
}

@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }

}


@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }

}

@media print {
  #print {
    display: block;
    border: none;
    width: 1200px;
    padding-right: 300px;
    margin-left: -200px;

  }


  nav.v-navigation-drawer, header.v-toolbar, button.v-btn, div.v-card {
    display: none;
    border: none;

  }

  @page {
    margin: 0;
  }

  body {
    margin: 1.6cm;
  }

  .hideOnPrint {
    display: none;
    border: none;
  }


}
</style>
